const smtPageDirectoryComponent = {
    section: {
        title: {
            color: {
                default: 'theme.500',
                _dark: 'theme.600'
            }
        }
    }
}

export default smtPageDirectoryComponent;